import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

import Home from "./pages/Home";
import Contact from "./pages/Contact";
import ProjectDetail from "./pages/ProjectDetail";
import Blog from "./pages/Blog";
import BlogDetail from "./pages/BlogDetail";
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";
import CustomCursor from "./components/ui/CustomCursor";

function App() {
    // Effet global pour gérer la navigation par ancres
    useEffect(() => {
        // Fonction pour gérer la navigation par hash
        const handleHashNavigation = () => {
            if (window.location.hash) {
                const hash = window.location.hash.split("?")[0].substring(1);

                // Attendre que les composants soient montés
                setTimeout(() => {
                    const element = document.getElementById(hash);
                    if (element) {
                        element.scrollIntoView({ behavior: "smooth" });

                        // Gestion des paramètres pour les sections spécifiques
                        if (hash === "services") {
                            const urlParams = new URLSearchParams(
                                window.location.hash.split("?")[1] || ""
                            );
                            const serviceId = urlParams.get("service");

                            if (serviceId) {
                                window.dispatchEvent(
                                    new CustomEvent("serviceSelected", {
                                        detail: { serviceId },
                                    })
                                );
                            }
                        }
                    }
                }, 100);
            }
        };

        // Gérer les changements d'URL et le chargement initial
        window.addEventListener("popstate", handleHashNavigation);
        window.addEventListener("load", handleHashNavigation);

        // Vérifier aussi après le chargement complet de la page
        if (document.readyState === "complete") {
            handleHashNavigation();
        } else {
            window.addEventListener("DOMContentLoaded", handleHashNavigation);
        }

        return () => {
            window.removeEventListener("popstate", handleHashNavigation);
            window.removeEventListener("load", handleHashNavigation);
            window.removeEventListener(
                "DOMContentLoaded",
                handleHashNavigation
            );
        };
    }, []);

    return (
        <HelmetProvider>
            <Router>
                <CustomCursor />
                <div className="App">
                    <Header />
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="project/:id" element={<ProjectDetail />} />
                        <Route path="/blog" element={<Blog />} />
                        <Route path="/blog/:slug" element={<BlogDetail />} />
                        {/* <Route path="/services" element={<Services />} />
                            <Route path="/projects" element={<Projects />} /> */}
                    </Routes>
                    <Footer />
                </div>
            </Router>
        </HelmetProvider>
    );
}

export default App;
